import { StateSchema } from 'app/config/storeConfig/types';
import { StepData } from 'features/Stepper';

export const getSteps = (state: StateSchema): StepData[] => state.createWarehouseModal.steps;
